// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"27":"f6b3d878","53":"2d2f73f1","332":"85384b97","643":"a64f7b4d","678":"1ed397b0","787":"b13e2d37","820":"aca830d1","991":"e60d64e2"}[chunkId] + ".js";
};